import React, { useCallback, useEffect, useState } from 'react'
import {
  Button,
  Checkbox,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Space,
  message,
} from 'antd'
import { useTranslation } from 'next-i18next'
import {
  API_BASE_URL,
  API_BASE_URL_TEMPORARY,
  regexEmail,
  TOURISTS_TO_VIETNAM_TYPE,
} from '../../constants'
import Image from 'next/image'
import callApiTemporary from '../../utils/callApiTemporary'
import axios from 'axios'

const bot = {
  TOKEN: '7173306115:AAG1HG-brWngxbm-pc3GdPwz3bteXlnN1kY',
  chatID: '-4100221254',
}

const URL_SCRIPT_GOOGLE =
  'https://script.google.com/macros/s/AKfycbxscrt3VGkJoAkRsV5u5-EV0ihYu4OlFe_4FLkrDfTZwxNtXknDqdZBQ5DHMRJdRE21/exec'

const { Option } = Select
const phoneNumber = '0888000800'
const SimOrder = () => {
  const { t, i18n } = useTranslation('simOrder')
  const language = i18n.language

  const [dataOptions, setDataOptions] = useState([])
  const [options, setOptions] = useState([])

  const [form] = Form.useForm()
  const [formTicketSupport] = Form.useForm()
  const [availableOptions, setAvailableOptions] = useState(options)
  const [mobile, setMobile] = useState(false)
  const [isTicketSupportValid, setIsTicketSupportValid] = useState(false)

  // useEffect(() => {
  //   setMobile(isMobile)
  // }, [])

  const [isSuccessModal, setIsSuccessModal] = useState(false)
  const [isCreatedTicketSupportModal, setIsCreatedTicketSupportModal] =
    useState(false)
  const [isCallInfoModal, setIsCallInfoModal] = useState(false)
  const [isSending, setIsSending] = useState(false)
  const [isShowSelector, setShowSelector] = useState(false)
  const saveGGSheet = (data) => {
    fetch(URL_SCRIPT_GOOGLE, {
      method: 'POST',
      body: JSON.stringify(data),
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => console.log(response))
      .catch((error) => console.log(error))
  }

  const onFinish = async (values) => {
    setIsSending(true)
    const url = `https://api.telegram.org/bot${bot.TOKEN}/sendMessage`
    const message = `Họ Tên: ${values.name}\nĐiện thoại: ${
      values.phone
    }\nEmail: ${values.email}\nĐịa chỉ: ${values.address}\nGhi chú: ${
      values.note ?? ''
    }\nSản phẩm:${values.products.reduce(
      (prevValue, currentValue) =>
        `${prevValue} \n ${currentValue.simType} |  số lượng: ${currentValue.amount}`,
      ''
    )}`
    try {
      const params = { chat_id: bot.chatID, text: message }
      await Promise.all([
        axios.post(url, params, {
          headers: { 'Content-Type': 'application/json' },
        }),
        axios.post(`${API_BASE_URL_TEMPORARY}/api/v1/tickets`, {
          ...values,
          title: 'Đơn đặt hàng',
          phone_number: values?.phone,
          description: `Sản phẩm:${values.products.reduce(
            (prevValue, currentValue) =>
              `${prevValue} \n ${currentValue.simType} |  số lượng: ${currentValue.amount}`,
            ''
          )}\nĐịa chỉ: ${values.address}\nGhi chú: ${values.note ?? ''}`,
          product_type: 'travel_sim',
        }),
      ])
      saveGGSheet(values)
      setIsSending(false)
      showModal()
      form.resetFields()
      form.setFieldValue('products', [{ simType: undefined, amount: 1 }])
      setAvailableOptions(
        dataOptions.map((item) => ({
          label: item.title ? item.title[language] : '',
          value: item.title ? item.title[language] : '',
        }))
      )
    } catch(error) {
      setIsSending(false)
      console.error(error)
    }

  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  const onFinishTicketSupport = async (values) => {
    setIsSending(true)
    try {
      await axios.post(`${API_BASE_URL}/api/v1/tickets`, {
        ...values,
        phone_number: values?.phone,
        title: 'Ticket Hỗ trợ từ Tourist Sim',
        description: `Họ Tên: ${values?.name}<br>Điện thoại: ${values?.phone_number}<br>Email: ${values?.email}<br>Sản phẩm: ${values?.product}`,
        product_type: 'travel_sim',
      })
      formTicketSupport.resetFields()
      setIsCreatedTicketSupportModal(true)
      setIsCallInfoModal(false)
    } catch (error) {
      message.error(t('error_create_ticket_processing'))
    } finally {
      setIsSending(false)
    }
  }

  const handleCall = useCallback(() => {
    if (mobile) {
      window.open(`tel:${phoneNumber}`)
    } else {
      setIsCallInfoModal(true)
    }
  }, [mobile])

  const showModal = () => {
    setIsSuccessModal(true)
  }
  const handleCancelTicketSupport = () => {
    setIsCallInfoModal(false)
    formTicketSupport.resetFields()
  }

  const handleSimTypeChange = (index, selectedValue) => {
    const currentValues = form.getFieldValue('products') || []
    const updatedValues = [...currentValues]
    updatedValues[index].simType = selectedValue
    form.setFieldsValue({ products: updatedValues })
    const selectedOptions = updatedValues.map((value) => value.simType)
    const remainingOptions = options.filter(
      (option) => !selectedOptions.includes(option.value)
    )
    setAvailableOptions(remainingOptions)
  }

  const handleRemove = (index) => {
    const values = form.getFieldValue('products')
    values.splice(index, 1)
    form.setFieldsValue({ products: values })
    const selectedOptions = values.map((item) => item.simType)
    const remainingOptions = options.filter(
      (option) => !selectedOptions.includes(option.value)
    )
    setAvailableOptions(remainingOptions)
  }

  const getData = async () => {
    try {
      const response = await callApiTemporary(`/api/v1/landing-products`, {
        params: {
          limit: 50,
          page: 1,
          product_type: TOURISTS_TO_VIETNAM_TYPE,
        },
      })
      const data = response?.data?.items || []
      setDataOptions(data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setTimeout(() => {
      setShowSelector(true)
    }, 5000)
    getData().then()
  }, [])

  useEffect(() => {
    if (dataOptions && dataOptions.length > 0) {
      const rs = dataOptions.map((item) => ({
        label: item.title ? item.title[language] : '',
        value: item.title ? item.title[language] : '',
      }))
      setOptions(rs)
      setAvailableOptions(rs)
    }
    form.resetFields()
  }, [dataOptions, language])

  const onValuesChange = () => {
    setIsTicketSupportValid(
      checkObjectValidity(formTicketSupport.getFieldsValue())
    )
  }

  const onFieldsChange = () => {
    setIsTicketSupportValid(
      checkObjectValidity(formTicketSupport.getFieldsValue())
    )
  }

  const checkObjectValidity = (obj) => {
    const requiredKeys = ['name', 'phone_number', 'product', 'isChecked']

    for (const key of requiredKeys) {
      if (
        !(key in obj) ||
        obj[key] === null ||
        obj[key] === undefined ||
        obj[key] === '' ||
        obj[key] === false
      ) {
        return false
      }
    }
    return true
  }

  return (
    <div className="container" id="sim-order">
      <div className="call-us">
        <button type="button" onClick={handleCall}>
          {t('call_us_to_order')}
        </button>
      </div>
      <div className="sim-order">
        <div className="header-block">
          <div className="header-title">
            <Image
              src="/images/common/send.svg"
              alt="send-icon"
              width={29}
              height={29}
            />
            <span className="ml-2">{t('order')}</span>
          </div>
          <div className="header-content">{t('description')}</div>
        </div>

        <div className="input-block">
          <Form
            form={form}
            name="basic"
            style={{ maxWidth: 484, width: '100%' }}
            initialValues={{ products: [{ simType: undefined, amount: 1 }] }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            disabled={isSending}
          >
            <Form.Item
              name="name"
              rules={[
                { required: true, message: t('message_input_your_name') },
              ]}
            >
              <Input placeholder={t('name')} />
            </Form.Item>
            <Form.Item
              name="phone"
              rules={[
                { required: true, message: t('message_input_your_phone') },
                // {
                //   pattern: regexPhoneNumber,
                //   message: t('message_input_valid_phone'),
                // },
              ]}
            >
              <Input placeholder={t('phone')} />
            </Form.Item>
            <Form.Item
              name="email"
              rules={[
                { required: true, message: t('message_input_your_email') },
                {
                  pattern: regexEmail,
                  message: t('message_input_valid_email'),
                },
              ]}
            >
              <Input placeholder={t('email')} />
            </Form.Item>
            <Form.Item
              name="address"
              rules={[
                { required: true, message: t('message_input_your_address') },
              ]}
            >
              <Input placeholder={t('address')} />
            </Form.Item>
            <Form.Item name="note">
              <Input.TextArea rows={3} placeholder={t('note')} />
            </Form.Item>
            <div className="item-section">
              <Form.List name="products">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) =>
                      isShowSelector ? (
                        <Space
                          key={field.key}
                          align="baseline"
                          style={{ width: '100%' }}
                        >
                          <Form.Item
                            style={{ width: '100%' }}
                            noStyle
                            shouldUpdate={() => true}
                          >
                            {() => (
                              <Form.Item
                                {...field}
                                name={[field.name, 'simType']}
                                rules={[
                                  {
                                    required: true,
                                    message: t('message_choose_product'),
                                  },
                                ]}
                              >
                                <Select
                                  size="large"
                                  placeholder={t('product')}
                                  onChange={(value) =>
                                    handleSimTypeChange(index, value)
                                  }
                                >
                                  {availableOptions.map((item) => (
                                    <Option
                                      key={item?.value}
                                      value={item?.value}
                                    >
                                      {item?.label}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            )}
                          </Form.Item>
                          <Form.Item
                            style={{ width: 75 }}
                            {...field}
                            name={[field.name, 'amount']}
                            rules={[{ required: true, message: ' ' }]}
                            initialValue={1}
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              size="large"
                              min={1}
                              maxLength={5}
                              defaultValue={1}
                            />
                          </Form.Item>
                          {fields?.length !== 1 && (
                            <div>
                              <a
                                className="icon-cancel"
                                onClick={() => handleRemove(index)}
                              >
                                {/* <img src="/images/common/sim-order-cancel.svg"
                                alt="cancel-icon"
                                width={31}
                                height={27} /> */}
                                <Image
                                  src="/images/common/icon-cancel.png"
                                  alt="cancel-icon"
                                  width={31}
                                  height={28}
                                />
                              </a>
                            </div>
                          )}

                          {/* <div
                          className={
                            index === 0 && fields?.length === 1
                              ? 'disabled-clear-btn'
                              : ''
                          }
                        >
                          <a onClick={() => handleRemove(index)}>
                            <Image
                              src="/images/common/sim-order-cancel.svg"
                              alt="cancel-icon"
                              width={31}
                              height={27}
                            />
                          </a>
                        </div> */}
                        </Space>
                      ) : (
                        <div key={field.key} />
                      )
                    )}

                    {fields?.length < dataOptions?.length &&
                      !!availableOptions?.length && (
                        <Form.Item>
                          <Button
                            size="large"
                            type="dashed"
                            onClick={() => add()}
                            block
                          >
                            {t('addProduct')}
                          </Button>
                        </Form.Item>
                      )}
                  </>
                )}
              </Form.List>
              <Form.Item className="submit-block">
                <button type="submit" disabled={isSending}>
                  {' '}
                  {t('orderNow')}
                </button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
      <Modal
        width="358px"
        open={isSuccessModal || isCreatedTicketSupportModal}
        footer={null}
        closable={false}
        onCancel={() => {
          setIsSuccessModal(false)
          setIsCreatedTicketSupportModal(false)
        }}
        centered
      >
        <div className="common-modal modal-register-success">
          <Image
            src="/images/landingPage/simplus-success.png"
            alt="phone"
            width={294}
            height={155}
          />
          <div className="title">
            {isCreatedTicketSupportModal
              ? t('modalCallInfo.thank')
              : t('modalSuccess.title')}
          </div>
          <div className="content">
            <div>
              {isCreatedTicketSupportModal
                ? t('modalCallInfo.keep_in_touch')
                : t('modalSuccess.content')}
            </div>
            {!isCreatedTicketSupportModal && (
              <div style={{ marginTop: '6px' }}>{t('modalSuccess.thank')}</div>
            )}
          </div>

          <button
            disabled={isSending}
            className="cancel-btn"
            onClick={() => {
              setIsSuccessModal(false)
              setIsCreatedTicketSupportModal(false)
              // window.location.reload()
            }}
          >
            {t('modalSuccess.cancel')}
          </button>
        </div>
      </Modal>
      <Modal
        width="600px"
        open={isCallInfoModal}
        footer={null}
        onCancel={handleCancelTicketSupport}
        closable={true}
        centered
      >
        <div className="modal-call-info">
          <div
            style={{ fontSize: '18px', fontWeight: '600', marginTop: '12px' }}
          >
            {t('modalCallInfo.title')}
          </div>
          <Form
            layout="vertical"
            name="messageForm"
            form={formTicketSupport}
            onFinish={onFinishTicketSupport}
            disabled={isSending}
            onValuesChange={onValuesChange}
            onFieldsChange={onFieldsChange}
          >
            <Form.Item
              label={t('modalCallInfo.name')}
              name="name"
              style={{ marginTop: '24px' }}
              rules={[
                { required: true, message: t('message_input_your_name') },
              ]}
            >
              <Input placeholder={t('name')} />
            </Form.Item>

            <Form.Item
              label={t('modalCallInfo.phone')}
              name="phone_number"
              rules={[
                { required: true, message: t('message_input_your_phone') },
                // {
                //   pattern: regexPhoneNumber,
                //   message: t('message_input_valid_phone'),
                // },
              ]}
            >
              <Input placeholder={t('phone')} />
            </Form.Item>

            <Form.Item
              label={t('modalCallInfo.email')}
              name="email"
              rules={[
                { required: true, message: t('message_input_your_email') },
                {
                  pattern: regexEmail,
                  message: t('message_input_valid_email'),
                },
              ]}
            >
              <Input placeholder={t('email')} />
            </Form.Item>

            <Form.Item name="product" label={t('modalCallInfo.product')}>
              <Select size="large" placeholder={t('product')}>
                {options.map((item) => (
                  <Option key={item?.value} value={item?.label}>
                    {item?.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <div className="commit">
              <Form.Item
                name="isChecked"
                valuePropName="checked"
                style={{ marginBottom: 0 }}
                rules={[
                  {
                    validator: (_, value) =>
                      value ? Promise.resolve() : Promise.reject(),
                  },
                ]}
              >
                <Checkbox className="text-commit">
                  {t('modalCallInfo.confirm_register')}
                </Checkbox>
              </Form.Item>
            </div>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ borderRadius: '10px', marginTop: '15px' }}
                disabled={!isTicketSupportValid}
              >
                {t('modalCallInfo.request-support')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  )
}

export default SimOrder
